import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import AgGrid from '../../shared/agGrid/agGrid.component';
import rolesColumnDefinitionFactory from '../../shared/columnDefinitions/rolesGrid';

const RolesPage = ({
  onGridReady: propOnGridReady,
  componentToRenderOnSearchBar,
  isGridLoading,
  addingNewRole,
  editedRoleId,
  onRowSelectedToEdit,
  onRowSelectedToDelete,
  areRolesLoading,
  onRowSelected,
  canModify,
  readOnly,
  getRowNodeId,
  context,
  setRowData,
  clients,
}) => {
  const [api, setApi] = useState(null);

  const isLoading = isGridLoading || areRolesLoading;

  const onGridReady = useCallback(({ api, ...rest }) => {
    setApi(api);
    propOnGridReady({ api, ...rest });
  }, [propOnGridReady]);

  const editClickedHandler = useCallback(roleId => {
    if (roleId === 'roleId') {
      return;
    }

    api.forEachNode(node => {
      if (node.data.roleId === roleId && !node.data.selected) {
        node.setSelected(true);
        api.startEditingCell(node);
        onRowSelectedToEdit(node.data);
      }
    });
  }, [api, onRowSelectedToEdit]);

  const removeClickedHandler = useCallback(roleId => {
    onRowSelectedToDelete(roleId);
  }, [onRowSelectedToDelete]);

  const columnDefinitions = rolesColumnDefinitionFactory({
    canModify,
    readOnly,
    onEditClick: editClickedHandler,
    onRemoveClick: removeClickedHandler,
    clients: clients?.map(({ clientId, shortName }) => ({ value: shortName, label: shortName, clientId })),
    editedRoleId,
    setRowData,
  });

  return (
    <div className="roles-grid page-content-container">
      <AgGrid
        className="ag-theme-bootstrap"
        componentToRenderOnSearchBar={componentToRenderOnSearchBar}
        columnDefs={columnDefinitions}
        withSearchBar
        disableSearchBar={addingNewRole}
        rowMultiSelectWithClick={false}
        onGridReady={onGridReady}
        isGridLoading={isLoading}
        isScrollDisabled={false}
        onRowSelected={onRowSelected}
        getRowId={getRowNodeId}
        context={context}
        stopEditingWhenCellsLoseFocus
        popupParent={document.querySelector('.roles-page')}
      />
      <ReactTooltip place="right" effect="float" />
    </div>
  );
};

RolesPage.propTypes = {
  componentToRenderOnSearchBar: PropTypes.node.isRequired,
  onGridReady: PropTypes.func.isRequired,
  isGridLoading: PropTypes.bool.isRequired,
  addingNewRole: PropTypes.bool.isRequired,
  editedRoleId: PropTypes.number.isRequired,
  isRoleModified: PropTypes.bool.isRequired,
  onRowSelectedToEdit: PropTypes.func.isRequired,
  onRowSelectedToDelete: PropTypes.func.isRequired,
  areRolesLoading: PropTypes.bool.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  canModify: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  getRowNodeId: PropTypes.func.isRequired,
  context: PropTypes.shape({}),
  setRowData: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({
    clientId: PropTypes.number.isRequired,
    shortName: PropTypes.string.isRequired,
  })).isRequired,
};

export default RolesPage;
